import { useHeaderVisible } from '@/hooks/layout';
import { useLogout } from '@/utils/app';
import { Grid, Layout } from 'antd';
import { createStyles } from 'antd-style';
import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import { AppHeader } from './Header';
import { Sidebar } from './Sidebar';

const { Content, Header } = Layout;

const { useBreakpoint } = Grid;
type LayoutProps = {
  children: ReactNode;
};

const siderCollapsedBreakpoint = 'xl';

const useStyles = createStyles(({ token, css }) => {
  return {
    container: css`
      min-height: 100vh;
      display: flex;
    `,
    content: css`
      transition: max-width 0.2s;
    `,
    header: css`
      padding: 0;
    `,
    main: css`
      display: flex;
      flex-direction: row;
    `,

    pageMain: css`
      display: flex;
      flex-direction: column;
      width: 0;
    `,
    sider: css`
      @media (max-width: ${token.screenXL}px) {
        position: fixed;
        z-index: 1;
        top: 0;
        bottom: 0;
        height: 100vh;
      }
    `,
  };
});

const LayoutAdmin: React.FC<LayoutProps> = ({ children }: LayoutProps): React.ReactElement => {
  const { styles } = useStyles();
  const { logout: logoutFn } = useLogout({ returnToCurrent: true });
  const screen = useBreakpoint();
  const [collapsed, setCollapsed] = useState<boolean>(true);
  const [headerVisible] = useHeaderVisible();
  const toggle = () => {
    setCollapsed(!collapsed);
  };

  const logout = useCallback(() => {
    logoutFn();
  }, []);

  useEffect(() => {
    setCollapsed(!screen[siderCollapsedBreakpoint]);
  }, [screen[siderCollapsedBreakpoint]]);

  return (
    <div className={styles.container}>
      <Layout className={styles.content}>
        {headerVisible ? (
          <Header className={styles.header}>
            <AppHeader collapsed={collapsed} toggle={toggle} onLogout={logout} />
          </Header>
        ) : null}
        <div className={styles.main}>
          <Sidebar
            collapsed={collapsed}
            onSelect={() => {
              if (!screen[siderCollapsedBreakpoint]) {
                setCollapsed(true);
              }
            }}
            onRequestCollapse={() => {
              setCollapsed(true);
            }}
          />
          <Content className={styles.pageMain}>{children}</Content>
        </div>
      </Layout>
    </div>
  );
};

export default LayoutAdmin;
